import { ORDER_BAG_STATUS, OrderBag } from "@/types";
import { RowData } from "./types";
import { CheckIcon } from "@/icons/Check";

type CardProps = {
  data: RowData;
  onSelect: (data: RowData) => void;
};

type CardDataProps = {
  data: RowData;
};

const Bag: React.FC<{ orderBag: OrderBag }> = ({ orderBag }) => {
  return (
    <span className="mr-4">
      <span key={orderBag.id}>{orderBag.sequence}</span>
      {typeof orderBag?.readyToSendAt === "string" && (
        <span className="text-green-600 w-100 text-center">
          <CheckIcon size={32} />
        </span>
      )}
    </span>
  );
};

const Bags: React.FC<CardDataProps> = ({ data }) => {
  return (
    <>
      {data.orderBags.map((orderBag) => (
        <Bag key={orderBag.id} orderBag={orderBag} />
      ))}
    </>
  );
};

const Card: React.FC<CardProps> = ({ data, onSelect }) => {
  // Only show a the Bin if any of the OrderBags have status QUALITYCHECK_BIN_BAGS
  const hasBagsWithStatus = data.orderBags.some(orderBag => orderBag.status === ORDER_BAG_STATUS.QUALITYCHECK_BIN_BAGS);
  if (!hasBagsWithStatus) {
    return null;
  }

  return (
  <div className="border rounded p-4 mb-2 bg-white">
    <div className="flex justify-between items-center">
      <div>
        <h6>Dossiernummer</h6>
        {data.bin?.order?.friendlyId}
      </div>
      <button className="bg-blue-500 text-white px-2 py-4 rounded" onClick={() => onSelect(data)}>
        Scan
      </button>
    </div>
    <div className="flex items-center mt-2 gap-6">
      <div>
        <h6>Bak</h6>
        <span className="whitespace-nowrap">{data.bin?.name}</span>
      </div>
      <div>
        <h6>Zakken</h6>
        <Bags data={data} />
      </div>
    </div>
  </div>
)};

export const List: React.FC<{
  onSelect: (data: RowData) => void;
  data: RowData[];
}> = ({ onSelect, data }) => {
  return (
    <div>
      {data.map((card) => (
        <Card key={card.key} data={card} onSelect={onSelect} />
      ))}
    </div>
  );
};
